import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { COLOR } from 'constants/colors';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getUserDetails } from '__utils/storage';
import styled from 'styled-components';
import { addAgentCode, decryptBase64, getQueryParamsFromString, isProUser, redirectToHome } from '__utils/common-utils';
import { useDispatch, useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import { CommonStyledComponentProps } from '__utils/type';
import { ENDPOINTS } from 'constants/endpoints';
import { getDefaultHeaders, post } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import useFlashToggler from 'hooks/use-flash-toggler';
import { getEncryptedUserId, redirectToOld, } from '__utils/common-utils';
import { LayoutContext } from 'components/app-routes';
import ProductDetailCard from './product-detail-card';
import elementVisibilty from '__utils/toggleVisibilty-util';
import { updateLoopBackUrl, updateTotalValidOrdersAmount } from '../payment-flow.actions';
import PaymentViewSelector from '../payment-flow.selector';
import CallNowSlab from 'components/call-now-slab';
import moment from 'moment';
import { Col, Row } from 'antd';
import { fetchUserProfileInfo } from 'views/user/user.actions';
import OrderSummaryCTASection from './order-summary-cta';
import { PaymentFlowHelper } from '../paymentFlow.helper';
import { updateUserPaymentViewAction } from '../payment-flow.actions';


const OuterContainer = styled.div<CommonStyledComponentProps>`
    padding: ${(props) => props.isMobile ? '16px' : ''};
    position: relative;
    .StickyFooter{
        background: #fff;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 8px;
        box-shadow: 0 2px 4px 4px #E0E0E0;
        z-index: 105;
        display: flex;
        button{
            flex: 1 1 0%;
        }
    }
    .StickyFooterWeb{
        display: flex;
    }

`;
const HeaderText = styled.p`
    margin-top:  0;
    font-size: 16px;
    font-weight: 500;
    .totalAmountText{
        position: absolute;
        right: 16px;
    }

`

const OrderSummary: React.FC = () => {
    const dispatch = useDispatch();
    const flash = useFlashToggler();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const [ isPaymentLinkExpired, setIsPaymentLinkExpired ] = useState<boolean>(false);
    const [ ordersList, setOrdersList ] = useState<any>();
    const [ validOrdersPresentFlag, setValidOrdersPresentFlag ] = useState<boolean>(false);
    const [ cartId, setCartId ] = useState<string>('');
    const [ linkValidTill, setLinkValidTill ] = useState<any>();
    const { totalValidOrdersAmount } = propsToJS(useSelector(PaymentViewSelector));
    const { getBSEorderDetails } = PaymentFlowHelper();

    useEffect(() => {
        SetLayoutProps({
            config: {
                goBackCallback: () => redirectToHome(),
                title: `Order Summary`,
            },
            showBseInfoForDesktop: false,
            showCopyrightInfoForDesktop: true,
            breadcrumbList: [ { text: 'Home', url: addAgentCode('v1/home'), isExternal: true }, { text: 'Investment Cart', url: '/cart-review', isExternal: true }, { text: 'Order Summary', url: '/order-summary', isExternal: false } ]
        });
        collectSearchParams();
        Mixpanel.track(getEventName("orderSummary", "loaded", "orderSummary"));
    }, []);

    //get paymenturl,ucc,loopbackurl from url params
    const collectSearchParams = () => {
        const paramsFromPath = new URLSearchParams(window.location.search);
        const paymentUrlFromPath = decryptBase64(paramsFromPath?.get('paymentUrl'));
        if (paymentUrlFromPath)
        {
            const { loopBackUrl, ucc, validTill, cartId } = getQueryParamsFromString(paymentUrlFromPath);
            loopBackUrl && dispatch(updateLoopBackUrl(loopBackUrl));
            cartId && setCartId(cartId);
            setLinkValidTill(validTill);
            if (getUserDetails())
            {
                if (decryptBase64(getEncryptedUserId()) === ucc)
                {
                    if (validTill && moment(validTill).utc() < moment(new Date().toUTCString()).utc())
                    {
                        setIsPaymentLinkExpired(true);
                    }
                    else
                    {
                        dispatch(fetchUserProfileInfo());
                        getOrders();
                    }
                }
                else
                {
                    flash.error('Oops! You are not authorised to view this page', 6000);
                    setTimeout(() => redirectToHome(), 6000)
                    // redirectToHome()
                }
            }
            else
            {
                elementVisibilty.show('loginDiv');
            }
        }
    }

    // get order details,o/p: store in orderslist,set validordersflag to true
    const getOrders = () => {
        const getOrderDetailsSuccess = (orderResponse?: any) => {
            if (orderResponse)
            {
                const validFirst = orderResponse.sort((a:any, b:any) => Number(b?.orderStatus === 'VALID') - Number(a?.orderStatus === 'VALID'));
                setOrdersList(validFirst);
                const validOrders = orderResponse?.filter((order: any) => order.orderStatus === 'VALID');
                if (validOrders?.length > 0)
                {
                    dispatch(updateUserPaymentViewAction(validOrders));
                    setValidOrdersPresentFlag(true);
                    let totalAmount = 0;
                    validOrders?.forEach((item: any) => totalAmount += item?.amount);
                    dispatch(updateTotalValidOrdersAmount(totalAmount));
                }
                else
                {
                    dispatch(updateUserPaymentViewAction(orderResponse));
                    postInvalidOrExpiredOrders(orderResponse, false);
                    setValidOrdersPresentFlag(false);
                }

            }
        }
        getBSEorderDetails(getOrderDetailsSuccess);

    }

    // call invaliorders endpoint if order invalid 
    const postInvalidOrExpiredOrders = (userPaymentDetailView: any, isPaymentLinkExpired: boolean) => {
        const invalidData = userPaymentDetailView && {
            orderDetailsList: userPaymentDetailView,
            isPaymentLinkExpired: isPaymentLinkExpired
        }
        post(ENDPOINTS.POST_INVALID_EXPIRED_ORDERS, invalidData, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
            }, (error: AjaxError) => {
            });
    }

    return (
        <OuterContainer isMobile={ isMobile }>
            {
                (ordersList || isPaymentLinkExpired) &&
                <div>
                    {!isMobile && <h3>Order Summary</h3>}
                    {isMobile && <div style={ { marginTop: '26px' } } />}

                    <Row gutter={ 32 } style={ { justifyContent: 'center' } }>
                        <Col xs={ 24 } md={ 17 }>

                            { (ordersList && !isPaymentLinkExpired) && ordersList?.map((item: any, index: number) => (
                                <ProductDetailCard key={ index } showAsAccordion accordionItem={ item } isPaymentLinkExpired={ isPaymentLinkExpired } />)
                            )
                            }

                            {
                                isPaymentLinkExpired ? <ProductDetailCard borderVariant={ COLOR.WARNING_DARK } accordionItem={ `This payment link has expired. Please go to cart and click on invest now to proceed with this order. ` }></ProductDetailCard>
                                    : <></>
                            }

                        </Col>

                        <Col xs={ 24 } md={ 7 }>
                            <OrderSummaryCTASection
                                isPaymentLinkExpired={ isPaymentLinkExpired }
                                validOrdersPresentFlag={ validOrdersPresentFlag }
                                linkValidTill={ linkValidTill }
                                cartId={ cartId }
                            />
                            <br />
                            { !isMobile && <CallNowSlab /> }
                        </Col>
                    </Row>
                </div >
            }
        </OuterContainer >

    )
}

export default OrderSummary;

